<template>
  <div slot="header" class="flex p-r-14">
    <div class="h-32 w-6 m-t-6 bg-2E85F8" style="transform: rotate3d(1, 1, 1, 21deg)"></div>
    <div class="h-32 w-2 m-t-6 m-l-6 bg-2E85F8" style="transform: rotate3d(1, 1, 1, 21deg)"></div>
  </div>
</template>
<script>

export default {
  props: {},
  data() {
    return {}
  },
  created() {
  },
  methods: {}
}
</script>
<style lang="less">
</style>

